<template>
  <div class="pack-list-item-footer">
    <div class="progress" :style="progressStyle"></div>
    <div class="stack">
      <div class="item" v-for="stack in item.stacks" :key="stack.index">
        <StackIcon :name="stack.name" size="24" />
      </div>
    </div>
    <div class="meta">
      <div class="count">{{ item.nodeCount }}节</div>
      <div class="duration">{{ item.duration }}</div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import StackIcon from '@/stack/components/stack-icon';

export default defineComponent({
  name: 'PackListItemFooter',

  /**
   * 属性
   */
  props: {
    item: Object,
    gradient: Object,
  },

  /**
   * 数据
   */
  data() {
    return {
      progressStyle: null,
    };
  },

  /**
   * 计算属性
   */
  computed: {
    //
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  mounted() {
    setTimeout(() => {
      this.progressStyle = {
        ...this.gradient,
        width: `${this.item.progress}%`,
      };
    }, 500);
  },

  /**
   * 组件方法
   */
  methods: {},

  /**
   * 使用组件
   */
  components: {
    StackIcon,
  },
});
</script>

<style scoped>
@import './styles/pack-list-item-footer.css';
</style>
